import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { Constants } from '../../app.const';
import { SharedConstants } from '../shared.const';

import { CookieManagerService } from './cookie-manager.service';
import { SpinnerService } from './spinner.service';
import { AlertManagerService } from './alert-manager.service';
import { LoginAgainService } from './login-again.service';

@Injectable()
export class HttpClientService {

  private headers;
  private requestQueueArray: Array<any> = [];
  private isRefresh: boolean = true;

  constructor(
    private http: Http,
    private alertService: AlertManagerService,
    private cookieService: CookieManagerService,
    private spinnerService: SpinnerService,
    private loginAgainService: LoginAgainService,
    private router: Router
    // private authService: AuthService,

  ) { }

  /**
   * Performs a request with `get` http method.
   * @param url
   * @returns {Observable<>}
   */
  get(url: string): Observable<any> {
    this.beforeStart();
    return this.http.get(this.getFullUrl(url), { headers: this.headers })
      .catch((error: any, caught: Observable<any>) => {
        return this.onCatch(error);
        // return Observable.throw(error);
      })
      .map((response: Response) => response.json())
      .finally(() => {
        this.onFinally();
      });
  }

  /**
     * Performs a request with `post` http method.
     * @param url
     * @param body
     * @returns {Observable<>}
     */
  post(url: string, body: any): Observable<any> {
    this.beforeStart();

    return this.http.post(this.getFullUrl(url), body, { headers: this.headers })
      .catch((error: any, caught: Observable<any>) => {
        this.onCatch(error);
        return Observable.throw(error);
      })
      .map((response: Response) => response.json())
      .finally(() => {
        this.onFinally();
      });
  }

  /**
   * Performs a request with `put` http method.
   * @param url
   * @param body
   * @param options
   * @returns {Observable<>}
   */
  put(url: string, body: any, isStop?: boolean): Observable<any> {
    this.beforeStart();
    return this.http.put(this.getFullUrl(url), body, { headers: this.headers })
      .catch((error: any, caught: Observable<any>) => {
        this.onCatch(error);
        return Observable.throw(error);
      })
      .map((response: Response) => response.json())
      .finally(() => {
        if(!isStop){
          this.onFinally();
        }
      });
  }

  /**
   * Performs a request with `delete` http method.
   * @param url
   * @param options
   * @returns {Observable<>}
   */
  delete(url: string): Observable<any> {
    this.beforeStart();

    return this.http.delete(this.getFullUrl(url), { headers: this.headers })
      .catch((error: any, caught: Observable<any>) => {
        this.onCatch(error);
        return Observable.throw(error);
      })
      .map((response: Response) => response.json())
      .finally(() => {
        this.onFinally();
      });
  }

  /**
   * Performs a request with `patch` http method.
   * Only refresh token
   * @param url
   * @param body
   * @param options
   * @returns {Observable<>}
   */
  patch(url: string, body: any): Observable<any> {
    this.beforeStart();
    return this.http.patch(this.getFullUrl(url), body, { headers: this.headers })
      .catch((error: any, caught: Observable<any>) => {
        this.onCatch(error);
        return Observable.throw(error);
      })
      .map((response: Response) => response.json())
      .finally(() => {
        this.onFinally();
      });
  }

  fileUpload(url: string, file: File): Observable<any> {
    this.requestInterceptor();
    let formData: FormData = new FormData();
    formData.append('cpmfile', file);
    this.headers = new Headers();
    this.headers.append('Authorization', 'Bearer ' + this.cookieService.getCookie(SharedConstants.basicConstans.cookieToken, false));
    this.headers.append('Accept', 'application/json');
    return this.http.post(this.getFullUrl(url), formData, { headers: this.headers })
      .catch((error: any, caught: Observable<any>) => {
        this.onCatch(error);
        return Observable.throw(error);
      })
      .map((response: Response) => response.json())
      .finally(() => {
        this.onFinally();
      });
  }

  private getRefreshTokrn(): Observable<any>{
    this.requestInterceptor();
    this.headers = new Headers();
    this.headers.append( SharedConstants.keyContentType, SharedConstants.valueContentType );
    let body = JSON.stringify({
      'key': this.cookieService.getCookie(SharedConstants.basicConstans.cookieUserKey, false)
    });
    return this.http.post(this.getFullUrl(SharedConstants.apiAuth), body, { headers: this.headers })
      .catch((error: any) => {
        return Observable.throw(error);
      })
      .map((response: Response) => {
        let body = response.json();
        this.cookieService.setCookie(SharedConstants.basicConstans.cookieToken, body.data[SharedConstants.keyToken], false, 1);
        return body;
      })
      .finally(() => {
        this.onFinally();
      });
  }

  /**
   * Request interceptor.
   */
  private requestInterceptor(): void {
    this.spinnerService.start();
  }

  /**
   * Response interceptor.
   */
  private responseInterceptor(): void {
    this.spinnerService.stop();
  }

  /**
   * Build API url.
   * @param url
   * @returns {string}
   */
  private getFullUrl(url: string) {
    return Constants.endPoint + '/' + url;
  }

  /**
   * onSubscribeSuccess
   * @param res
   */
  private onSubscribeSuccess(res: Response): void {
  }

  /**
   * onSubscribeError
   * @param error
   */
  private onSubscribeError(error: any): void {
  }

  /**
   * onFinally
   */
  private onFinally(): void {
    this.responseInterceptor();
  }

  private beforeStart() {

    this.requestInterceptor();

    this.headers = new Headers();
    this.createAuthorizationHeader();
  }

  private createAuthorizationHeader(): void {
    this.headers.append('Authorization', 'Bearer ' + this.cookieService.getCookie(SharedConstants.basicConstans.cookieToken, false));
    this.headers.append(SharedConstants.keyContentType, SharedConstants.valueContentType);
  }

  /**
   * Error handler.
   * @param error
   * @param caught
   * @returns {ErrorObservable}
   */
  private onCatch(error): Observable<any>{
    let err = error.json();
    if(err && err.message){
      if(err.status_code === 401){
        // if(this.isRefresh){
        //   this.isRefresh = false;
        //   this.getRefreshTokrn().subscribe(
        //     res=> {
        //       this.loginAgainService.isOpen(true);
        //     }
        //   );
        // }
        this.cookieService.removeAllCookie();
        this.router.navigate(['preauth/login']);
        return Observable.throw(err);
      }else{
        this.alertService.error({title: "", msg: err.message});    
        return Observable.throw(err);    
      }
    }else{
      this.alertService.error({title: "", msg: "Server Error"});
      return Observable.throw(err);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/http-client.service.ts